import { Partial } from '@40seas/entities/common';
import { InsuranceCompany } from './insurance.company.entity';

export class UpdateInsuranceCompanyDto extends Partial(InsuranceCompany) {}
